// import $ from 'jquery';
import { gsap } from 'gsap';
import { indexOf as _indexOf } from 'underscore';
import { debounce as _debounce } from 'underscore';
import Cookies from 'js-cookie';

export default class alertBar{

    constructor(options) {

        this.defaults = {
        	main 			: undefined,
        	$el   			: $( '#alert-bar' ),

        	debug 			: false,

       	}
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'alert-bar';
		this.main			= this.options.main;
		this.$el 			= this.options.$el;
		this.$window 		= $(window);

		this.is_ticker 		= false;
		this.$text 			= this.$el.find( '.text' );
		this.$int 			= this.$el.find( '.int' );

		this.init( true );

    }

    init( b ){


    	this.debounceResize( b );
    }

    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => this.onResize(), 17 );
			this.$window.on( 'resize', this._debResize );

			this.onResize()
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$window.off( 'resize', this._debResize );
			}        
		}
    }

    onResize(){
    	if ( this.is_ticker ){
    		if ( this.$text.length > 0 ){
    			if ( this.$text.width() < this.$window.width() ){
    				this.createTicker( false );
    			}
    		}
    	}
    	else{
    		if ( this.$text.length > 0 ){
    			if ( this.$text.width() > this.$window.width() ){
    				this.createTicker( true );
    			}
    		}
    	}
    }

    createTicker( b ){
    	let $clone;
    	if ( b ){
    		$clone = this.$text.clone( true );
    		$clone.addClass( 'cloned' );
    		this.$int.append( $clone );

    		this.startTicker( true );
    	}
    	else{
    		
    		this.startTicker( false );

    		$clone = this.$int.find( '.cloned' );
    		if ( $clone.length > 0 ){
    			$clone.remove();
    		}
    	}
    	this.is_ticker = b;
    }

    startTicker( b ){
		if ( this.id_ticker ){
			cancelAnimationFrame( this.id_ticker );
		}
		if ( b ){
			this.tick();
		}
    	else{
    		gsap.set( this.$int, {x:0} );
    	}
    }

    tick(){
		this.translate();
		this.id_ticker = requestAnimationFrame( () => this.tick() );
	}

	translate(){
		let x = gsap.getProperty( this.$int[0] , "x")? gsap.getProperty( this.$int[0] , "x"):0;
		if ( x < - this.$text.width() ){
			x = 0;
		}
		else{
			x -= 1;
		}
		gsap.set( this.$int, {x:x} );
	}

    destroy(){
    	this.init( false );
    }

}



